export const LANDING_HEADER_CANTON_URL =
  process.env.LANDING_HEADER_CANTON_URL || "https://www.vd.ch/";

export const LANDING_HEADER_DIP_URL =
  process.env.LANDING_HEADER_DIP_URL ||
  "https://www.vd.ch/def/dgeo/#cipeo";

export const LANDING_HEADER_IMPRESSUM_URL =
  process.env.LANDING_HEADER_IMPRESSUM_URL || "https://support.edu-vd.ch";

export const LANDING_FOOTER_COMMUNICATION_URL =
    process.env.LANDING_FOOTER_COMMUNICATION_URL || "/uploads/mentis-communication-affiche.pdf";

export const HELP_URL =
  process.env.HELP_URL || "https://support.edu-vd.ch/support/solutions/50000022734";

export const LANDING_VIDEO_EMBED_URL =
  process.env.LANDING_VIDEO_EMBED_URL ||
  "https://expeer.eduge.ch/videos/embed/d5d6e2b4-4e51-4013-81b4-d76cc2360776?title=0&warningTitle=0&controlBar=0&peertubeLink=0&p2p=0";

export const DOCUMENTATION_URL = "https://support.edu-vd.ch/support/solutions/50000022734";
export const PRIVACY_POLICY_URL = "https://education-numerique.edu-vd.ch/politique-de-confidentialite/";
